export interface ChartTransactionScope {
	target_id: number;
	target_type: "client" | "merchant" | "project";
	from: string;
	to: string;
	currency: string;
	channel_id?: number;
	projectId: number;
	userId: number;
}

export interface ChartBucket { from: string; to: string }
const DAY = 86400000;

/** Match overview/get's UTC scale, including duplicate hour labels over two days. */
export function getChartBucket(points: { label: string }[], index: number, from: string, to: string): ChartBucket | null {
	if (!Number.isInteger(index) || !points[index]) return null;
	const start = Date.parse(`${from}T00:00:00Z`);
	const last = Date.parse(`${to}T00:00:00Z`);
	if (!Number.isFinite(start) || !Number.isFinite(last) || last < start) return null;
	const days = (last - start) / DAY;
	const interval = days <= 1 ? "hour" : days <= 31 ? "day" : days <= 180 ? "week" : "month";
	const date = new Date(start);
	if (interval === "week") date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 6) % 7);
	if (interval === "month") date.setUTCDate(1);
	if (interval === "hour") date.setUTCHours(date.getUTCHours() + index);
	else if (interval === "month") date.setUTCMonth(date.getUTCMonth() + index);
	else date.setUTCDate(date.getUTCDate() + index * (interval === "week" ? 7 : 1));
	const iso = date.toISOString();
	const label = interval === "hour" ? iso.slice(11, 16)
		: interval === "month" ? `${iso.slice(5, 7)}.${iso.slice(0, 4)}` : `${iso.slice(8, 10)}.${iso.slice(5, 7)}`;
	// Do not query a guessed period if the server changes the scale format.
	if (points[index].label !== label) return null;
	const end = new Date(date);
	if (interval === "hour") end.setUTCHours(end.getUTCHours() + 1);
	else if (interval === "month") end.setUTCMonth(end.getUTCMonth() + 1);
	else end.setUTCDate(end.getUTCDate() + (interval === "week" ? 7 : 1));
	const lower = Math.max(start, date.getTime());
	const upper = Math.min(last + DAY, end.getTime());
	return lower < upper ? { from: new Date(lower).toISOString(), to: new Date(upper).toISOString() } : null;
}

/** Fixed server filters shared by every page of the Sessions table. */
export function getChartTransactionsFilters(scope: ChartTransactionScope, bucket: ChartBucket) {
	return {
		from: bucket.from.slice(0, 16).replace("T", " "),
		to: new Date(Date.parse(bucket.to) - 1).toISOString().slice(0, 16).replace("T", " "),
		currency: scope.currency,
	};
}
